import 'assets/styles/style.scss';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import * as Sentry from '@sentry/react';

import { hydrate, render } from 'react-dom';

import { Integrations } from '@sentry/tracing';
import Loadable from 'react-loadable';
import React from 'react';
import App from './app';

const renderMethod = module.hot ? render : hydrate;

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

Loadable.preloadReady().then(() => {
  renderMethod(<App />, document.getElementById('root'));
});
